export default __webpack_public_path__ + "static/media/bell.e5ed2c4e.svg";